exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TabBarNode__tab-bar-node___3zu0U{display:inline-block;height:100%;line-height:normal;padding:10px 0;margin:0 18px 0 0;white-space:nowrap;cursor:pointer;transition:color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);flex:none;font-family:'Bai Jamjuree', sans-serif;max-width:75px !important;overflow:hidden;text-overflow:ellipsis}.TabBarNode__tab-bar-node___3zu0U:last-child{margin-right:0}\n", ""]);

// Exports
exports.locals = {
	"button-width-size": "32",
	"no-scroll-padding": "12",
	"tab-bar-node": "TabBarNode__tab-bar-node___3zu0U"
};